const TrueValue = 'true';
export const AppName = 'clearcar-dpe';

export const isDev = process.env.NODE_ENV === 'development';
export const isProd = process.env.NODE_ENV === 'production';

export const AcvPricingEnabled = process.env.ACV_PRICING_ENABLED === TrueValue;
export const AnalyticsApiKey = process.env.ANALYTICS_API_KEY;
export const AnalyticsIsEnabled =
  process.env.ANALYTICS_IS_ENABLED === TrueValue;
export const AttrEnableEmail = process.env.ATTR_ENABLE_EMAIL === TrueValue;
export const AutoCheckAuthorization = process.env.AUTO_CHECK_AUTHORIZATION;
export const AutoCheckUrl = process.env.AUTO_CHECK_URL;
export const ClearCarUrl = process.env.DRIVABLY_URL;
export const PortalUrl = process.env.PORTAL_URL;
export const HasuraUrl = process.env.HASURA_URL;
export const InspectionUrl = process.env.INSPECTION_URL;
export const LogKey = process.env.LOG_KEY ?? '';
export const LogEnv = process.env.LOG_ENV ?? '';
export const LogEnabled = process.env.LOG_ENABLED === 'true';
export const MapsApiKey = process.env.MAPS_API_KEY;
export const MapsUrl = process.env.MAPS_URL;
export const MonkInspectionBaseUrl = process.env.MONK_INSPECTION_BASE_URL;
export const MonkMessageSender = process.env.MONK_MESSAGE_SENDER;
export const ScanditApiKey = process.env.SCANDIT_API_KEY;
export const SingleApiUrl = process.env.SINGLE_API_URL;
export const UsedCarClubUrl = process.env.USED_CAR_CLUB_URL;
export const VehicleSearchYmmUrl = process.env.VEHICLE_SEARCH_YMM_URL;
export const VehicleTaxonomyAuthorization =
  process.env.VEHICLE_TAXONOMY_AUTHORIZATION;
export const VehicleTaxonomyUrl = process.env.VEHICLE_TAXONOMY_URL;
export const VinScannerUrl = process.env.VIN_SCANNER_URL;

// Analytics constants
export const GTMSrcID = 'drvtrd-gtm-script';
export const GTMFrameID = 'drvtrd-gtm-iframe';

// Lower offer threshold for ACV pricing. Otherwise, BB pricing is used.
export const PriceThresholdUsd = 50000;

// On local, make static url dynamic so assets are served correctly even from external ip
export const AssetsUrl = isDev
  ? `${window.location.origin}/static/`
  : process.env.ASSETS_URL;

export const ContactPhonePrefix = '+1';
export const StoreIDByrider = '102';
export const DisplayNameDefault = 'Clear Car';

export const AcvDealerId = '199';
export const DivID = 'drvtrd-container';
export const QuickQuoteDivID = 'drvtrd-quick-quote';
export const FirstStepID = 'drvtrd-step-vehicle-id';

export const EmailOfferFrom = 'appraisals@mail1.drivably.com';
export const EmailOfferFromAlias = `${DisplayNameDefault} Appraisal`;
export const EmailOfferSubject = `${DisplayNameDefault} Trade Offer`;

export const LogoColorExternal = '#585959';

// Time delay before redirecting to offer page
export const OfferDuration = 3000;

// Keep this in sync with deployment config
export const ScriptSrcProd = 'https://drvtrd-widget.netlify.app/drivably.js';

// Configuration for specific vehicles by make and model
export const VehicleConfig: {
  make: string;
  hasVinDecodeIssue: boolean;
}[] = [
  {
    make: 'ford',
    hasVinDecodeIssue: true,
  },
];

export const USStates: string[] = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const CarColors: {
  name: string;
  code: string;
  hex: string;
}[] = [
  { name: 'Black', code: 'black', hex: '#000' },
  { name: 'Blue', code: 'blue', hex: '#00f' },
  { name: 'Brown', code: 'brown', hex: '#964b00' },
  { name: 'Gray', code: 'gray', hex: '#808080' },
  { name: 'Green', code: 'green', hex: '#0f0' },
  { name: 'Orange', code: 'orange', hex: '#f60' },
  { name: 'Purple', code: 'purple', hex: '#60f' },
  { name: 'Red', code: 'red', hex: '#f00' },
  { name: 'Silver', code: 'silver', hex: '#c0c0c0' },
  { name: 'Tan', code: 'tan', hex: '#d2b48c' },
  { name: 'White', code: 'white', hex: '#fff' },
  { name: 'Yellow', code: 'yellow', hex: '#ff0' },
];

// Offer Expiration Day
export const OfferExpirationDays = 7;
export const USLocaleDate = 'en-US';

export enum CameraMode {
  Front = 'user',
  Rear = 'environment',
}
//Dealer ID to get WholeSale offer
export const WholesaleOfferDealerId = 350;

export const OfferDealerTextLimit = 80;
